import { surveyFormsService } from "../../../../../Api/Services/SurveyFormsService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import {
  ICreateSectionPayload,
  ICreateSectionResponse,
} from "../../../../../Types/SurveyFormsTypes";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

export const saveSection = createServiceAsyncThunk<
  ICreateSectionResponse,
  ICreateSectionPayload
>(
  ACTION_NAMES.SAVE_UPDATE_SECTION,
  (payload) => surveyFormsService.saveSection(payload),
  ERROR_MESSAGES.SAVE_UPDATE_SECTION_FAILURE
);

const saveUpdateSectionSlice = createGenericSlice<
  ICreateSectionResponse,
  ICreateSectionPayload
>(SLICE_NAMES.SAVE_UPDATE_SECTION_SLICE, saveSection);

export const {
  clearError: clearSaveSectionError,
  clearSuccessMessage: clearSaveSectionSuccessMessage,
} = saveUpdateSectionSlice.actions;

export default saveUpdateSectionSlice.reducer;
